import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './assets/styles/RichContent.css';
import App from './App';

// Frontendning eng birinchi kirish nuqtasi:
// root DOM node topiladi va butun sayt `App` orqali render qilinadi.
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
